import { Route, Routes } from "react-router-dom";
import ChatBotPage from "./chatbot/ChatBotPage";
import AiWebSearch from "./aiWebSearch/aiwebsearch/AiWebSearch";
import WaveFlowMainPage from "../page/waveflow/WaveFlowMainPage";
import Models from "./waveflow/models/Models";
import Tools from "./waveflow/tools/Tools";
import WorkFlowAdminMain from "./WorkFlowAdmin/WorkFlowAdminMain";
import FileHub from "./waveflow/DataHub/FileHub";
import PromptTest from "./waveflow/agentEvalutionMain/PromptTest";
import Protected from "../components/protected/Protected";
import ObservabilityDashboard from "../page/AiObservabilty/ObservabilityDashboard";

//supabase setup
import PrivateRoute from "../Supabase/pages/PrivateRoute";
import Payment from "./Payments/Payment";

function MainRoutes() {
  return (
    <Routes>
      <Route path="/aiweb-search" element={<AiWebSearch />} />
      <Route path="/Ai-Observability" element={<ObservabilityDashboard />} />
      <Route path="/chatbot" element={<ChatBotPage />} />
      <Route path="/Agent-Generation" element={<WaveFlowMainPage />} />
      <Route path="/models" element={<Models />} />
      <Route path="/tools" element={<Tools />} />
      <Route path="/workflow-testing" element={<PromptTest />} />
      <Route path="/workflow-admin" element={<WorkFlowAdminMain />} />
      <Route path="/payment" element={<Payment />} />
      <Route
        path="/data-hub"
        element={
          <Protected permissionRequired="DocumentUpload">
            <FileHub />
          </Protected>
        }
      />
      <Route path="/" element={<WaveFlowMainPage />} />

      <Route
        path="/Agent-Generation"
        element={
          <PrivateRoute>
            <WaveFlowMainPage />
          </PrivateRoute>
        }
      />
    </Routes>
  );
}

export default MainRoutes;
